import { ELEMENT_TYPE } from '@vindr/services/apis/element.api';
import { FC } from 'react';
import DateTime from './components/elements/datetime/DateTime';
import GenerateList from './components/elements/generate-list/GenerateList';
import ImageInput from './components/elements/image/ImageInput';
import Input from './components/elements/input/Input';
import Selection from './components/elements/selection/Selection';
import StructureInput from './components/elements/structured/StructureInput';
import { StructuredReportElement } from './components/elements/types';

export interface InputComponentElementProps {
  element: StructuredReportElement;
  onChange: (value: any, element: StructuredReportElement, preventHighlight?: boolean) => void;
  disabled: boolean;
  index?: number;
}

const InputComponentElement: FC<InputComponentElementProps> = ({
  element,
  onChange,
  disabled,
  index,
  ...props
}) => {
  const handleChange = (newValue, changedElement, preventHighlight) => {
    // This should the only place we set value to element. Don't do that again anywhere.
    changedElement.setValue(newValue);
    onChange(newValue, changedElement, preventHighlight);
  };

  const defaultProps = {
    onChange: handleChange,
    disabled,
    index,
    ...props,
  };

  if (!element?.type) return null;

  switch (element.type) {
    case ELEMENT_TYPE.INPUT_TEXT:
      return <Input element={element} {...defaultProps} />;
    case ELEMENT_TYPE.DATE_TIME:
      return <DateTime element={element} {...defaultProps} />;
    case ELEMENT_TYPE.IMAGE:
      return <ImageInput element={element} {...defaultProps} />;
    case ELEMENT_TYPE.DROPDOWN_LIST:
      return <Selection element={element as any} {...defaultProps} />;
    case ELEMENT_TYPE.GENERATED_LIST:
      return <GenerateList element={element as any} {...defaultProps} />;
    case ELEMENT_TYPE.STRUCTURE:
      // Recursively render structured elements
      return <StructureInput onChange={handleChange} {...{ element, disabled, index }} />;
    default:
      return null;
  }
};

export default InputComponentElement;
